export default __webpack_public_path__ + "static/media/credisis-logo.f59b8bdd.png";